var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('v-alert',{attrs:{"type":_vm.type == 'success' ? 'success' : 'error',"icon":_vm.type == 'success' ? 'mdi-check-circle' : 'mdi-alert'}},[_vm._v(_vm._s(_vm.message))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }